export default "__VITE_ASSET__BIIQTrgp__"